<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2023-09-27 15:43:16
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-09-11 14:55:05
 * @Description:
 * @FilePath: \haozhang_pro\src\components\publicTable\column\OperColumn.vue
-->
<template>
	<el-table-column
		column-key="operation"
		:label="columnOperation.label"
		:min-width="columnOperation.width"
		:class-name="columnOperation.value"
		:fixed="columnOperation.fixed">
		<template slot-scope="scope">
			<el-button
				type="text"
				v-for="item in columnOperation.data"
				:key="item.value"
				:class="{'red': item.value == 'delete'}"
				v-text="item.label"
				v-if="!scope.row.standard"
				@click.native.stop="handleOperation(item.value, scope.row)">
			</el-button>
		</template>
	</el-table-column>
</template>

<script>
export default {
	name: 'TableColumn',
	props: {
		columnOperation: {
			type: Object,
			default () {
				return {
					label: '操作',
					value: 'operation',
					data: []
				}
			}
		}
	},
	methods: {
		handleOperation (methods, row) {
			this.$emit('onHandleoperate', {
				methods,
				row
			})
		},
	},
}
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/publicTable/column/OperColumn.vue